// import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-notifications/lib/notifications.css';
import 'src/styles/main.scss'; // Uvoz SCSS stila
import { NotificationContainer } from 'react-notifications';
import ModalManager from 'src/components/ModalManager';
import { Link, Route, Routes } from "react-router-dom";
import Home from "src/pages/Home";
import Contact from "src/pages/Contact";
import Ad from "src/pages/Ad";
import NotFound from "src/pages/NotFound";
import Login from 'src/pages/Login';
import Register from 'src/pages/Register';
import ResetPassword from 'src/pages/ResetPassword';
import EmailVerified from 'src/pages/EmailVerified';
import Search from 'src/pages/Search';
import Logout from 'src/pages/Logout';
import Settings from 'src/pages/my/Settings';
import Profil from 'src/pages/Profil';
import PostAd from 'src/pages/PostAd';
import EditAd from 'src/pages/my/EditAd';
import ScrollToTop from "src/components/ScrollToTop";
import UserProfil from 'src/pages/UserProfile';
import Favorites from 'src/pages/Favorites';
import MyAdverts from 'src/pages/my/MyAdverts';
import BlogList from 'src/pages/blog/Blog';
import BlogPost from 'src/pages/blog/BlogPost';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { CookiesProvider } from 'react-cookie';
import CookieConsent from 'src/components/CookieConsent';
import PrivacyPolicy from 'src/pages/PrivacyPolicy';
import TermsAndConditions from 'src/pages/TermsAndConditions';
import ProtectedRoute from 'src/components/common/ProtectedRoute';
import usePing from 'src/hooks/usePing';


function App() {
  const dispatch = useDispatch();
  
  // Povremeno proveravaj da li je korisnik i dalje prijavljen i da li su bile promene
  usePing(15000); // Ping svakih 15 sekundi

  // Sinhronizuj logout i login između tabova
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'logout') {
        // Drugi tab je izvršio logout - odjavi i ovaj tab
        dispatch({ type: 'LOGOUT' });
        // Ne redirect-uj automatski, korisnik može da nastavi da koristi stranicu kao gost
      } else if (e.key === 'login') {
        // Drugi tab je izvršio login - ažuriraj stanje u ovom tabu
        // Koristimo LOGIN_SYNC umesto LOGIN_SUCCESS da izbegnemo beskonačnu petlju
        const token = localStorage.getItem('token');
        const userStr = localStorage.getItem('user');
        
        if (token && userStr) {
          try {
            const user = JSON.parse(userStr);
            dispatch({ 
              type: 'LOGIN_SYNC', 
              payload: { token, user } 
            });
          } catch (error) {
            console.error('Error parsing user data:', error);
          }
        }
      }
    };

    // Slušaj promene u localStorage (između tabova)
    window.addEventListener('storage', handleStorageChange);

    // Proveri da li je već bilo logout-a u drugom tabu
    const logoutTimestamp = localStorage.getItem('logout');
    if (logoutTimestamp) {
      // Ako je logout bio u poslednjih 5 sekundi, odjavi i ovaj tab
      const timestamp = parseInt(logoutTimestamp, 10);
      if (Date.now() - timestamp < 5000) {
        dispatch({ type: 'LOGOUT' });
      }
    }

    // Proveri da li je već bilo login-a u drugom tabu
    const loginTimestamp = localStorage.getItem('login');
    if (loginTimestamp) {
      // Ako je login bio u poslednjih 5 sekundi, ažuriraj stanje
      const timestamp = parseInt(loginTimestamp, 10);
      if (Date.now() - timestamp < 5000) {
        const token = localStorage.getItem('token');
        const userStr = localStorage.getItem('user');
        
        if (token && userStr) {
          try {
            const user = JSON.parse(userStr);
            // Koristimo LOGIN_SYNC da ne bismo ponovo setovali localStorage
            dispatch({ 
              type: 'LOGIN_SYNC', 
              payload: { token, user } 
            });
          } catch (error) {
            console.error('Error parsing user data:', error);
          }
        }
      }
    }

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [dispatch]);

  return (
    <CookiesProvider>
      <ScrollToTop />
      <NotificationContainer />
      <ModalManager />
      <CookieConsent />
      
      <Routes>
        <Route path="/logout" element={<Logout />}/>
        <Route path="/" element={<Home />} />
      
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/email-verified" element={<EmailVerified />} />
        <Route path="/post-ad" element={<PostAd />} />

        <Route path="/search" element={<Search />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/ad">
          <Route path=":id/:slug" element={<Ad />}></Route>
        </Route>
        <Route path="/profil">
          <Route path=":slug" element={<Profil />}></Route>
          <Route path="" element={<NotFound />}></Route>
        </Route>
        
        <Route path="/my">
          <Route path="settings" element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }></Route>
          <Route path="ads" element={
            <ProtectedRoute>
              <MyAdverts />
            </ProtectedRoute>
          } />
          <Route path="favorites" element={
            <ProtectedRoute>
              <Favorites />
            </ProtectedRoute>
          } />
          <Route path="ad/:id/edit" element={
            <ProtectedRoute>
              <EditAd />
            </ProtectedRoute>
          } />
        </Route>

        <Route path="/blog">
          <Route path="" element={<BlogList />} />
          <Route path=":slug" element={<BlogPost />} />
        </Route>

        <Route path="user-profil" element={<UserProfil />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </CookiesProvider>
  );
}

export default App;
